function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleteBasics, importBasics, prohibitBasics, lookBasics, queryPageBasics, saveBasics, getExcelPath, download } from '@/api/baseDataManage';
import { getCompanyList, getCoInsurer as _getCoInsurer } from '@/api/baseDate';
export default {
  name: 'BcIntermediarySet',
  data: function data() {
    return {
      codeTypeList: [],
      //代码类型列表
      codeTypeCname1: '',
      // -----------------------------------
      affiliationComList: [],
      fileList: [],
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配1
      // 查询条件
      form: {
        codeType: '',
        //代码类型
        insuranceCompanyCode: '',
        //保险公司code 必传
        pageNo: 1,
        //第几页
        pageSize: 10,
        //多少条
        validStatus: '',
        //是否有效
        validStatusName: '',
        codeTypeName: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        codeTypeCname: '',
        codeCname: '',
        //业务代码中文名称
        codeCode: '',
        //业务代码
        codeEname: '',
        //业务代码英文名称
        codeLevel: '',
        codeType: '',
        //代码类型
        id: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        typeName: '',
        //代码类型描述
        updateTime: '',
        upperCode: '',
        validStatus: '',
        type: '' //是否是编辑按钮 1-是,0-否 (如果是编辑按钮,如果是,就传1,如果是单条新增按钮,就传0) !必传

      },
      markForm_new: {
        codeTypeCname: '',
        codeCname: '',
        //业务代码中文名称
        codeCode: '',
        //业务代码
        codeEname: '',
        //业务代码英文名称
        codeLevel: '',
        codeType: '',
        //代码类型
        id: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        typeName: '',
        //代码类型描述
        updateTime: '',
        upperCode: '',
        validStatus: '',
        type: '' //是否是编辑按钮 1-是,0-否 (如果是编辑按钮,如果是,就传1,如果是单条新增按钮,就传0) !必传

      },
      limitrule: {
        codeTypeCname: [{
          required: true,
          message: '请选择代码类型',
          trigger: 'blur'
        }],
        codeCname: [{
          required: true,
          message: '请输入业务代码中文名称',
          trigger: 'blur'
        }],
        codeCode: [{
          required: true,
          message: '请输入业务代码',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();

      _this.getCoInsurer();
    });
  },
  methods: {
    // 查询代码类型列表变化
    changecodeCode: function changecodeCode(e) {
      console.log(e);
      this.form.codeTypeName = e;
      this.form.codeType = e.split('-')[0];
    },
    //保存/新增代码列表变化
    changeCodeType: function changeCodeType(e) {
      this.markForm_new.codeType = e.split('-')[0];
      this.markForm_new.typeName = e.split('-')[1];
      this.markForm.codeType = e.split('-')[0];
      this.markForm.typeName = e.split('-')[1];
    },
    // 获取代码类型list
    getCoInsurer: function getCoInsurer() {
      var _this2 = this;

      _getCoInsurer({
        codeType: "insuranceCodeType"
      }).then(function (res) {
        console.log(res);
        _this2.codeTypeList = Object.assign([], res);
      });
    },
    // 新增
    newbut: function newbut() {
      this.newumarBtn = true; // this.getCoInsurer()
      // this.affiliationCom = ''  //
    },
    // 查询是否有效 下拉框change
    changeStatus: function changeStatus(e) {
      console.log(e);
      this.form.validStatus = e.toString();
    },
    // --------------------------------------------
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      this.loading = true;
      queryPageBasics(_objectSpread({}, this.form)).then(function (res) {
        console.log(res);
        _this3.loading = false;
        _this3.total = res.totalCount;
        _this3.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.codeType = '', //代码类型
      this.form.validStatus = '', //是否有效
      this.form.validStatusName = '';
      this.form.codeTypeName = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this4 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.new_edit = _this4.newumarBtn = false;

          _this4.openFullScreen();

          saveBasics(data).then(function (res) {
            // console.log(res)
            if (res.resultCode == '0000') {
              _this4.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this4.markForm_new) {
                _this4.markForm_new[key] = '';
              }

              _this4.getData();
            } else {
              _this4.$alert(res.resultMsg, '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this4.newumarBtn = type == 'new' ? true : false;
                  _this4.new_edit = type == 'edit' ? true : false;
                }
              });
            }

            _this4.screenLoading.close();

            _this4.affiliationCom = ''; //
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      console.log(data);
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }

      this.markForm.codeTypeCname = data.codeType + '-' + data.typeName;
      this.editData = data;
      console.log(this.markForm); // console.log(this.markForm_new)
    },
    // // 删除
    // dele(data) {
    //   console.log(data)
    //   this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     deleteBasics({ intermediaryId: data.intermediaryId, intermediaryOrganCode: data.intermediaryOrganCode }).then(res => {
    //       // console.log(res)
    //       if (res.resultCode == '0000') {
    //         this.$message({
    //           type: 'success',
    //           message: '删除成功!'
    //         })
    //         this.getData()
    //       } else {
    //         this.$message({
    //           type: 'warning',
    //           message: res.resultMsg
    //         })
    //       }
    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    // 禁用
    noRight: function noRight(data, status) {
      var _this5 = this;

      console.log(data);
      var str = '';
      if (status == '0') str = '禁用';else str = '启用';
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(str, "\u8BE5\u6570\u636E\u4FE1\u606F, \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        prohibitBasics({
          id: data.id,
          status: status
        }).then(function (res) {
          if (res.resultCode == "0000") {
            _this5.$message({
              type: 'success',
              message: res.resultMsg
            });

            _this5.getData(1);
          } else {
            _this5.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this6 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this6.$refs[formname].clearValidate();
      });
      this.affiliationCom = '';
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'InsuranceCode'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "保险公司基础数据导入模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "保险公司基础数据导入模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this7 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      importBasics(dataFile).then(function (res) {
        _this7.screenLoading.close();

        if (res.resultCode == '0000') {
          _this7.$message({
            type: 'success',
            message: '导入成功'
          });

          _this7.getData();
        } else {
          _this7.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};